"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverCarouselFooterButton", {
    enumerable: true,
    get: function() {
        return TeachingPopoverCarouselFooterButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopoverCarouselFooterButton = require("./useTeachingPopoverCarouselFooterButton");
const _renderTeachingPopoverCarouselFooterButton = require("./renderTeachingPopoverCarouselFooterButton");
const _useTeachingPopoverCarouselFooterButtonStylesstyles = require("./useTeachingPopoverCarouselFooterButtonStyles.styles");
const TeachingPopoverCarouselFooterButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverCarouselFooterButton.useTeachingPopoverCarouselFooterButton_unstable)(props, ref);
    (0, _useTeachingPopoverCarouselFooterButtonStylesstyles.useTeachingPopoverCarouselFooterButtonStyles_unstable)(state);
    return (0, _renderTeachingPopoverCarouselFooterButton.renderTeachingPopoverCarouselFooterButton_unstable)(state);
});
TeachingPopoverCarouselFooterButton.displayName = 'TeachingPopoverCarouselFooterButton';
